export function Footer() {
  return (
    <footer className="border-t border-[#23211c] bg-ink pb-28 pt-10 lg:pb-10">
      <div className="mx-auto flex max-w-6xl flex-col items-start justify-between gap-6 px-4 sm:flex-row sm:items-center sm:px-6 lg:px-8">
        <p className="font-display text-lg text-paper">
          SayIt<span className="text-brand">.</span>
        </p>
        <div className="flex items-center gap-6 text-[13px] text-[#8a8578]">
          <a href="#demo" className="transition-colors hover:text-paper">Demo</a>
          <a href="#pricing" className="transition-colors hover:text-paper">Pricing</a>
          <a href="#faq" className="transition-colors hover:text-paper">FAQ</a>
        </div>
        <p className="text-[13px] text-[#6b675c]">
          © 2026 SayIt. Checkout & delivery by Lemon Squeezy.
        </p>
      </div>
    </footer>
  );
}
